import { render, staticRenderFns } from "./IosSignRule.vue?vue&type=template&id=557bdc5e"
import script from "./IosSignRule.vue?vue&type=script&lang=js"
export * from "./IosSignRule.vue?vue&type=script&lang=js"
import style0 from "./IosSignRule.vue?vue&type=style&index=0&id=557bdc5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports